import React from 'react';
import PropTypes from 'prop-types';
import { FDIcon, FDTooltip } from '@facet-wealth/design';
import { inputPropTypes } from 'Packages/FacetDesign/Components/propTypes';
import { useDataAttrs } from 'Helpers/Testing';

function Tooltip({ value, size, ...rest }) {
  return (
    <FDTooltip
      {...useDataAttrs(rest)}
      title={value}
    >
      <FDIcon icon="tooltip" size={size} color="primary" />
    </FDTooltip>
  );
}

Tooltip.defaultProps = {
};

Tooltip.propTypes = {
  size: inputPropTypes.size.isRequired,
  value: PropTypes.string.isRequired,
};


export const TooltipSmall = (props) => {
  return <Tooltip {...props} size="sm" />;
};

export const TooltipLarge = (props) => {
  return <Tooltip {...props} size="lg" />;
};
